import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export enum WorkflowStepEnumType {
  None = 0,
  Eviction = 10,
  Notice = 50,
  MoveOut = 100,
  Bid = 200,
  MakeReady = 250,
  Reno = 300,
  Punch = 350,
  Approval = 400,
  Marketing = 500,
  LeaseUp = 600,
  MoveIn = 700,
  Archive = 800,
}

export enum ProjectWorkflowStepEnumLabels {
  Notice = 'Draft',
  MoveOut = 'Kick off',
  MakeReady = 'In progress',
  MoveIn = 'Done',
}

export const PROJECT_WORKFLOW_STEPS: IRadioButtonOption<number>[] = [
  {
    label: ProjectWorkflowStepEnumLabels.Notice,
    value: WorkflowStepEnumType.Notice,
    displayValue: ProjectWorkflowStepEnumLabels.Notice.toUpperCase(),
  },
  {
    label: ProjectWorkflowStepEnumLabels.MoveOut,
    value: WorkflowStepEnumType.MoveOut,
    displayValue: ProjectWorkflowStepEnumLabels.MoveOut.toUpperCase(),
  },
  {
    label: ProjectWorkflowStepEnumLabels.MakeReady,
    value: WorkflowStepEnumType.MakeReady,
    displayValue: ProjectWorkflowStepEnumLabels.MakeReady.toUpperCase(),
  },
  {
    label: ProjectWorkflowStepEnumLabels.MoveIn,
    value: WorkflowStepEnumType.MoveIn,
    displayValue: ProjectWorkflowStepEnumLabels.MoveIn.toUpperCase(),
  },
];
